import api from "../../apiClient"

/**
 * admin/Group
 */

export const getGroupList = async () => {
    console.log(`@getGroupList`)
    const response = await api.get(`/group/list`)
    return response.data
}

export const getGroupDetail = async (groupIdx) => {
    console.log(`@getGroupDetail - groupIdx: ${groupIdx}`)
    const response = await api.get(`/group/detail/${groupIdx}`)
    return response.data
}

export const createGroup = async (data) => {
    console.log("@createGroup")
    const response = await api.post(`/admin/group`, data)
    return response.data
}

export const modifyGroup = async (data) => {
    console.log("@modifyGroup")
    const response = await api.put(`/admin/group`, data)
    return response.data
}

export const modifyGroupMember = async (data) => {
    console.log("@modifyGroup")
    const response = await api.put(`/admin/group/${data.groupIdx}/member`, { user: data.userIdxList })
    return response.data
}

export const deleteGroup = async ({ idx }) => {
    const response = await api.delete(`/admin/group`, { 
        data: { idx } 
    })
    return response.data
}